import { render, staticRenderFns } from "./ModalSingleOptionSelector.vue?vue&type=template&id=bffa65b0"
import script from "./ModalSingleOptionSelector.vue?vue&type=script&lang=js"
export * from "./ModalSingleOptionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports